function buildPrescriptionHtml(visit, patient, clinicSettings, includeControls = true) {
  const logo = clinicSettings?.clinic_logo_url || '';
  const clinicName = clinicSettings?.clinic_name || '1Clin';
  const clinicAddr = clinicSettings?.clinic_address || '';
  const clinicPhone = clinicSettings?.clinic_phone || '';
  const doctorReg = clinicSettings?.doctor_registration || '';
  const tagline = clinicSettings?.tagline || 'Healthcare Simplified, Care Amplified.';
  const appBaseUrl = process.env.REACT_APP_BACKEND_URL || window.location.origin;
  const scanUrl = visit.prescription_barcode ? `${appBaseUrl}/scan/${visit.prescription_barcode}` : '';

  // Generate logo HTML - use image if available, otherwise text logo
  const logoHtml = logo 
    ? `<img src="${logo}" alt="${clinicName}" />`
    : `<div style="width:44px;height:44px;border-radius:8px;background:linear-gradient(135deg,#14b8a6,#0f766e);display:flex;align-items:center;justify-content:center;color:white;font-family:'Manrope',sans-serif;font-weight:700;font-size:16px;">1C</div>`;

  const visitDate = visit.created_at ? new Date(visit.created_at).toLocaleDateString('en-IN') : new Date().toLocaleDateString('en-IN');

  return `<!DOCTYPE html>
<html><head><meta charset="utf-8"><title>Prescription - ${patient?.name || ''}</title>
<style>
  @import url('https://fonts.googleapis.com/css2?family=Manrope:wght@400;600;700&family=DM+Sans:wght@400;500&display=swap');
  * { margin: 0; padding: 0; box-sizing: border-box; }
  @page { size: A4; margin: 10mm; }
  body { font-family: 'DM Sans', sans-serif; color: #1e293b; background: #fff; padding: 20px; max-width: 210mm; margin: 0 auto; }
  .page-container { display: flex; min-height: calc(297mm - 20mm); }
  .main-content { width: 75%; padding-right: 20px; border-right: 2px dashed #e2e8f0; }
  .manual-space { width: 25%; padding-left: 16px; display: flex; flex-direction: column; }
  .manual-header { font-size: 11px; color: #94a3b8; text-transform: uppercase; letter-spacing: 0.1em; margin-bottom: 8px; text-align: center; }
  .manual-lines { flex: 1; background: repeating-linear-gradient(transparent, transparent 24px, #f1f5f9 24px, #f1f5f9 25px); }
  .header { display: flex; justify-content: space-between; align-items: flex-start; margin-bottom: 16px; padding-bottom: 12px; border-bottom: 3px solid #0f766e; }
  .logo-section { display: flex; align-items: center; gap: 10px; }
  .logo-section img { width: 44px; height: 44px; border-radius: 8px; object-fit: contain; }
  .clinic-name { font-family: 'Manrope', sans-serif; font-size: 17px; font-weight: 700; color: #0f766e; }
  .tagline { font-size: 8px; color: #94a3b8; }
  .clinic-info { font-size: 10px; color: #64748b; margin-top: 2px; }
  .rx-symbol { font-size: 24px; font-weight: 700; color: #0f766e; margin: 12px 0 6px; font-family: serif; }
  .patient-info { display: grid; grid-template-columns: 1fr 1fr; gap: 6px; background: #f8fafc; padding: 10px; border-radius: 6px; margin-bottom: 12px; font-size: 11px; }
  .patient-info .label { color: #94a3b8; font-size: 9px; text-transform: uppercase; }
  .patient-info .value { font-weight: 500; }
  .section-title { font-family: 'Manrope', sans-serif; font-size: 11px; font-weight: 700; color: #0f766e; margin: 12px 0 6px; text-transform: uppercase; letter-spacing: 0.05em; border-bottom: 1px solid #e2e8f0; padding-bottom: 3px; }
  table { width: 100%; border-collapse: collapse; margin: 6px 0 12px; font-size: 10px; }
  th { background: #f1f5f9; padding: 6px 8px; text-align: left; font-weight: 600; border-bottom: 1px solid #e2e8f0; }
  td { padding: 5px 8px; border-bottom: 1px solid #f1f5f9; }
  .diagnosis-tags { display: flex; gap: 4px; flex-wrap: wrap; margin: 4px 0; }
  .diagnosis-tag { background: #f0fdfa; color: #0f766e; padding: 2px 8px; border-radius: 99px; font-size: 9px; font-weight: 500; }
  .followup { background: #fef3c7; padding: 8px; border-radius: 6px; font-size: 10px; margin-top: 10px; }
  .footer { margin-top: 30px; display: flex; justify-content: space-between; align-items: flex-end; }
  .signature { text-align: right; }
  .signature .line { border-top: 1px solid #1e293b; width: 150px; margin-left: auto; margin-bottom: 3px; }
  .footer-tagline { text-align: center; font-size: 9px; color: #94a3b8; margin-top: 16px; border-top: 1px solid #e2e8f0; padding-top: 8px; }
  .vitals-grid { display: grid; grid-template-columns: repeat(3, 1fr); gap: 4px; font-size: 9px; margin-bottom: 8px; }
  @media print { body { padding: 10px; } .no-print { display: none; } }
</style></head>
<body>
  ${includeControls ? `<div class="no-print" style="margin-bottom:12px;text-align:right">
    <button onclick="window.print()" style="background:#0f766e;color:white;border:none;padding:8px 20px;border-radius:6px;cursor:pointer;font-size:13px;font-weight:600">Print</button>
  </div>` : ''}
  <div class="page-container">
    <div class="main-content">
      <div class="header">
        <div class="logo-section">
          ${logoHtml}
          <div>
            <div class="clinic-name">${clinicName}</div>
            <div class="tagline">${tagline}</div>
            ${clinicAddr ? `<div class="clinic-info">${clinicAddr}</div>` : ''}
            ${clinicPhone ? `<div class="clinic-info">Ph: ${clinicPhone}</div>` : ''}
          </div>
        </div>
        <div style="text-align:right;font-size:10px;color:#64748b">
          <div style="font-weight:600;font-size:12px;color:#1e293b">${visit.doctor_name || 'Doctor'}</div>
          ${doctorReg ? `<div>Reg: ${doctorReg}</div>` : ''}
          <div>Date: ${visitDate}</div>
          ${scanUrl ? `<div style="margin-top:4px"><img src="https://api.qrserver.com/v1/create-qr-code/?size=48x48&data=${encodeURIComponent(scanUrl)}" alt="Rx QR" style="width:48px;height:48px;display:inline-block" /><div style="font-size:7px;color:#94a3b8;margin-top:1px">Scan to order</div><div style="font-size:8px;font-family:monospace;font-weight:700;color:#475569;letter-spacing:0.1em;margin-top:1px">${visit.prescription_barcode}</div></div>` : ''}
        </div>
      </div>
      <div class="patient-info">
        <div><span class="label">Patient</span><div class="value">${patient?.name || ''}</div></div>
        <div><span class="label">Age / Gender</span><div class="value">${patient?.age || '-'}y / ${patient?.gender || '-'}</div></div>
        <div><span class="label">Phone</span><div class="value">${patient?.phone || '-'}</div></div>
        <div><span class="label">Blood Group</span><div class="value">${patient?.blood_group || '-'}</div></div>
      </div>
      ${visit.vitals ? `<div class="vitals-grid">
        ${visit.vitals.bp_systolic ? `<div>BP: ${visit.vitals.bp_systolic}/${visit.vitals.bp_diastolic}</div>` : ''}
        ${visit.vitals.pulse ? `<div>Pulse: ${visit.vitals.pulse}</div>` : ''}
        ${visit.vitals.temperature ? `<div>Temp: ${visit.vitals.temperature}\u00B0F</div>` : ''}
        ${visit.vitals.spo2 ? `<div>SpO2: ${visit.vitals.spo2}%</div>` : ''}
        ${visit.vitals.weight ? `<div>Wt: ${visit.vitals.weight}kg</div>` : ''}
        ${visit.vitals.height ? `<div>Ht: ${visit.vitals.height}cm</div>` : ''}
      </div>` : ''}
      ${visit.diagnosis?.length ? `<div class="diagnosis-tags">${visit.diagnosis.map(d => `<span class="diagnosis-tag">${d}</span>`).join('')}</div>` : ''}
      <div class="rx-symbol">Rx</div>
      ${visit.medications?.length ? `<table><thead><tr><th>#</th><th>Medicine</th><th>Dosage</th><th>Frequency</th><th>Duration</th></tr></thead><tbody>
        ${visit.medications.filter(m => m.name).map((m, i) => `<tr><td>${i+1}</td><td>${m.name}</td><td>${m.dosage || '-'}</td><td>${m.frequency || '-'}</td><td>${m.duration || '-'}</td></tr>`).join('')}
      </tbody></table>` : '<p style="font-size:10px;color:#94a3b8">No medications prescribed</p>'}
      ${visit.lab_tests?.length ? `<div class="section-title">Lab Tests</div><table><thead><tr><th>#</th><th>Test</th><th>Type</th></tr></thead><tbody>
        ${visit.lab_tests.map((t, i) => `<tr><td>${i+1}</td><td>${t.name}</td><td>${t.type || 'blood'}</td></tr>`).join('')}
      </tbody></table>` : ''}
      ${visit.radiology?.length ? `<div class="section-title">Radiology</div><table><thead><tr><th>#</th><th>Study</th><th>Type</th></tr></thead><tbody>
        ${visit.radiology.map((r, i) => `<tr><td>${i+1}</td><td>${r.name}</td><td>${r.type || 'xray'}</td></tr>`).join('')}
      </tbody></table>` : ''}
      ${visit.treatments?.length ? `<div class="section-title">Treatment</div><table><thead><tr><th>#</th><th>Treatment</th><th>Type</th></tr></thead><tbody>
        ${visit.treatments.map((t, i) => `<tr><td>${i+1}</td><td>${t.name}</td><td>${t.type || 'treatment'}</td></tr>`).join('')}
      </tbody></table>` : ''}
      ${visit.follow_up_date ? `<div class="followup"><strong>Follow-up:</strong> ${visit.follow_up_date}</div>` : ''}
      ${visit.plan ? `<div class="section-title">Instructions</div><p style="font-size:10px;line-height:1.4">${visit.plan}</p>` : ''}
      <div class="footer">
        <div style="font-size:9px;color:#94a3b8">${clinicName}</div>
        <div class="signature"><div class="line"></div><div style="font-size:10px;font-weight:600">Signature</div></div>
      </div>
      <div class="footer-tagline">${tagline}</div>
    </div>
    <div class="manual-space">
      <div class="manual-header">Doctor's Notes</div>
      <div class="manual-lines"></div>
    </div>
  </div>
</body></html>`;
}

export function openPrescriptionPrint(visit, patient, clinicSettings) {
  const html = buildPrescriptionHtml(visit, patient, clinicSettings, true);
  const win = window.open('', '_blank');
  win.document.write(html);
  win.document.close();
}

export async function downloadPrescriptionPdf(visit, patient, clinicSettings) {
  const html = buildPrescriptionHtml(visit, patient, clinicSettings, false);
  const html2pdf = (await import('html2pdf.js')).default;
  const filename = `Prescription_${(patient?.name || 'Patient').replace(/[^a-zA-Z0-9]/g, '_')}.pdf`;
  await html2pdf().from(html, 'string').set({
    margin: 0,
    filename,
    html2canvas: { scale: 2, useCORS: true },
    jsPDF: { unit: 'mm', format: 'a4', orientation: 'portrait' }
  }).save();
}

// WhatsApp share function for prescription
export function sharePrescriptionWhatsApp(visit, patient, clinicSettings) {
  const clinicName = clinicSettings?.clinic_name || '1Clin';
  const visitDate = visit.created_at ? new Date(visit.created_at).toLocaleDateString('en-IN') : new Date().toLocaleDateString('en-IN');
  
  let message = `*${clinicName} - Prescription*\n\n`;
  message += `Patient: ${patient?.name || 'N/A'}\n`;
  message += `Date: ${visitDate}\n\n`;
  
  if (visit.diagnosis?.length) {
    message += `*Diagnosis:* ${visit.diagnosis.join(', ')}\n\n`;
  }
  
  if (visit.medications?.length) {
    message += `*Medications:*\n`;
    visit.medications.filter(m => m.name).forEach((m, i) => {
      message += `${i+1}. ${m.name} ${m.dosage || ''} - ${m.frequency || ''} for ${m.duration || ''}\n`;
    });
    message += '\n';
  }
  
  if (visit.follow_up_date) {
    message += `*Follow-up:* ${visit.follow_up_date}\n`;
  }
  
  if (visit.plan) {
    message += `\n*Instructions:*\n${visit.plan}\n`;
  }
  
  message += `\n_Generated by ${clinicName}_`;
  
  const phoneNumber = patient?.phone?.replace(/[^0-9]/g, '') || '';
  const whatsappUrl = phoneNumber 
    ? `https://wa.me/91${phoneNumber}?text=${encodeURIComponent(message)}`
    : `https://wa.me/?text=${encodeURIComponent(message)}`;
  
  window.open(whatsappUrl, '_blank');
}

export function openOnlineConsultationPrescriptionPrint(consultation) {
  const rx = consultation.prescription;
  if (!rx) return;

  const date = rx.created_at ? new Date(rx.created_at).toLocaleDateString('en-IN') : new Date().toLocaleDateString('en-IN');
  const appBaseUrl = process.env.REACT_APP_BACKEND_URL || window.location.origin;
  const rxBarcode = rx.prescription_barcode || consultation.prescription_barcode;
  const scanUrl = rxBarcode ? `${appBaseUrl}/scan/${rxBarcode}` : '';

  const medicinesHtml = (rx.medicines || []).map((m, i) => `
    <tr>
      <td>${i + 1}</td>
      <td style="font-weight:600">${m.name}</td>
      <td>${m.dosage || '-'}</td>
      <td>${m.frequency || '-'}</td>
      <td>${m.duration || '-'}</td>
      <td>${m.instructions || '-'}</td>
    </tr>
  `).join('');

  const testsHtml = (rx.tests || []).map((t, i) => `
    <tr><td>${i + 1}</td><td>${t.name}</td><td>${t.instructions || '-'}</td></tr>
  `).join('');

  const html = `<!DOCTYPE html>
<html><head><meta charset="utf-8"><title>Prescription - ${rx.patient_name || ''}</title>
<style>
  @import url('https://fonts.googleapis.com/css2?family=Manrope:wght@400;600;700&family=DM+Sans:wght@400;500&display=swap');
  * { margin: 0; padding: 0; box-sizing: border-box; }
  @page { size: A4; margin: 12mm; }
  body { font-family: 'DM Sans', sans-serif; color: #1e293b; background: #fff; padding: 24px; max-width: 210mm; margin: 0 auto; }
  .header { display: flex; justify-content: space-between; align-items: flex-start; margin-bottom: 16px; padding-bottom: 12px; border-bottom: 3px solid #0f766e; }
  .logo { width:44px;height:44px;border-radius:8px;background:linear-gradient(135deg,#14b8a6,#0f766e);display:flex;align-items:center;justify-content:center;color:white;font-family:'Manrope',sans-serif;font-weight:700;font-size:16px; }
  .title { font-family: 'Manrope', sans-serif; font-size: 18px; font-weight: 700; color: #0f766e; }
  .subtitle { font-size: 10px; color: #94a3b8; }
  .badge { display: inline-block; background: #e0f2fe; color: #0369a1; font-size: 9px; padding: 2px 8px; border-radius: 99px; margin-top: 4px; }
  .info-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 6px; background: #f8fafc; padding: 12px; border-radius: 8px; margin-bottom: 16px; font-size: 11px; }
  .info-grid .label { color: #94a3b8; font-size: 9px; text-transform: uppercase; }
  .info-grid .value { font-weight: 500; }
  .rx { font-size: 28px; font-weight: 700; color: #0f766e; margin: 12px 0 8px; font-family: serif; }
  .section { font-family: 'Manrope', sans-serif; font-size: 12px; font-weight: 700; color: #0f766e; margin: 14px 0 6px; text-transform: uppercase; border-bottom: 1px solid #e2e8f0; padding-bottom: 3px; }
  table { width: 100%; border-collapse: collapse; margin: 6px 0 12px; font-size: 11px; }
  th { background: #f1f5f9; padding: 7px 8px; text-align: left; font-weight: 600; border-bottom: 1px solid #e2e8f0; }
  td { padding: 6px 8px; border-bottom: 1px solid #f1f5f9; }
  .advice { background: #f0fdf4; border: 1px solid #bbf7d0; padding: 10px; border-radius: 6px; font-size: 11px; margin: 8px 0; }
  .followup { background: #fef3c7; padding: 8px 12px; border-radius: 6px; font-size: 11px; margin-top: 10px; }
  .footer { margin-top: 40px; display: flex; justify-content: space-between; align-items: flex-end; }
  .sig-line { border-top: 1px solid #1e293b; width: 150px; margin-bottom: 3px; }
  .footer-note { text-align: center; font-size: 9px; color: #94a3b8; margin-top: 20px; border-top: 1px solid #e2e8f0; padding-top: 8px; }
  @media print { body { padding: 10px; } .no-print { display: none; } }
</style></head>
<body>
  <div class="no-print" style="margin-bottom:12px;text-align:right">
    <button onclick="window.print()" style="background:#0f766e;color:white;border:none;padding:8px 20px;border-radius:6px;cursor:pointer;font-size:13px;font-weight:600">Download / Print</button>
  </div>
  <div class="header">
    <div style="display:flex;align-items:center;gap:10px">
      <div class="logo">1C</div>
      <div>
        <div class="title">1Clin</div>
        <div class="subtitle">Online Consultation Prescription</div>
        <div class="badge">Video Consultation</div>
      </div>
    </div>
    <div style="text-align:right;font-size:11px;color:#64748b">
      <div style="font-weight:600;font-size:13px;color:#1e293b">${rx.doctor_name || ''}</div>
      <div>${rx.doctor_specialty || ''}</div>
      <div>Date: ${date}</div>
      ${scanUrl ? `<div style="margin-top:4px"><img src="https://api.qrserver.com/v1/create-qr-code/?size=48x48&data=${encodeURIComponent(scanUrl)}" alt="Rx QR" style="width:48px;height:48px;display:inline-block" /><div style="font-size:7px;color:#94a3b8;margin-top:1px">Scan to order</div><div style="font-size:8px;font-family:monospace;font-weight:700;color:#475569;letter-spacing:0.1em;margin-top:1px">${rxBarcode}</div></div>` : ''}
    </div>
  </div>

  <div class="info-grid">
    <div><span class="label">Patient</span><div class="value">${rx.patient_name || ''}</div></div>
    <div><span class="label">Consultation Date</span><div class="value">${consultation.scheduled_date || consultation.preferred_date || '-'}</div></div>
    <div><span class="label">Consultation Reason</span><div class="value">${consultation.reason || '-'}</div></div>
    <div><span class="label">Consultation ID</span><div class="value" style="font-size:9px">${consultation.id || '-'}</div></div>
  </div>

  <div class="rx">℞</div>

  <div class="section">Diagnosis</div>
  <p style="font-size:12px;font-weight:600;margin-bottom:8px">${rx.diagnosis}</p>

  ${(rx.medicines || []).length > 0 ? `
    <div class="section">Medicines</div>
    <table>
      <thead><tr><th>#</th><th>Medicine</th><th>Dosage</th><th>Frequency</th><th>Duration</th><th>Instructions</th></tr></thead>
      <tbody>${medicinesHtml}</tbody>
    </table>
  ` : ''}

  ${(rx.tests || []).length > 0 ? `
    <div class="section">Investigations</div>
    <table>
      <thead><tr><th>#</th><th>Test</th><th>Instructions</th></tr></thead>
      <tbody>${testsHtml}</tbody>
    </table>
  ` : ''}

  ${rx.advice ? `<div class="advice"><strong>Advice:</strong> ${rx.advice}</div>` : ''}
  ${rx.follow_up_date ? `<div class="followup"><strong>Follow-up:</strong> ${rx.follow_up_date}</div>` : ''}

  <div class="footer">
    <div style="font-size:10px;color:#94a3b8">Generated via 1Clin Online Consultation</div>
    <div style="text-align:right">
      <div class="sig-line"></div>
      <div style="font-size:11px;font-weight:600">${rx.doctor_name || ''}</div>
      <div style="font-size:10px;color:#64748b">${rx.doctor_specialty || ''}</div>
    </div>
  </div>
  <div class="footer-note">This is a computer-generated prescription from an online consultation. Please consult your doctor for any queries.</div>
</body></html>`;

  const w = window.open('', '_blank');
  if (w) { w.document.write(html); w.document.close(); }
}

